<script setup>
import { inject, computed } from 'vue';
import { useProductsStore } from '@/app/stores/productsStore.js';
import { useValue } from '@/app/composables/useValue.js';

const productsStore = useProductsStore();

const config = inject('config');
const props = defineProps(['dataPoint']);
const system = computed(() => productsStore.system);

const nonRangeData = computed(() => {
  return {
    value:
      props.dataPoint.label ||
      props.dataPoint[`${system.value}Value`]?.toString() ||
      props.dataPoint.value?.toString() ||
      '',
    unit: props.dataPoint[`${system.value}Unit`] || props.dataPoint.unit || '',
    optionalValue:
      (system.value === 'imperial' && props.dataPoint.imperialValueOptional?.toString()) || '',
    optionalUnit:
      (system.value === 'imperial' && props.dataPoint.imperialUnitOptional?.toString()) || '',
  };
});
</script>

<template>
  <div
    v-if="nonRangeData.value"
    class="c-product-card__details-set"
    itemprop="additionalProperty"
    itemscope
    itemtype="https://schema.org/PropertyValue"
  >
    <dt class="c-product-card__details-title" itemprop="name">{{ dataPoint.title }}</dt>
    <dd class="c-product-card__details-data">
      <span v-if="nonRangeData.value" itemprop="value"
        >{{ useValue(nonRangeData.value) }}&nbsp;</span
      >
      <span v-if="nonRangeData.unit && nonRangeData.value" itemprop="unitText"
        >{{ nonRangeData.unit }}&nbsp;</span
      >
      <span v-if="nonRangeData.optionalValue" itemprop="value"
        >{{ useValue(nonRangeData.optionalValue) }}&nbsp;</span
      >
      <span v-if="nonRangeData.optionalUnit && nonRangeData.optionalValue" itemprop="unitText"
        >{{ nonRangeData.optionalUnit }}&nbsp;</span
      >
    </dd>
  </div>
</template>